const NITRO_COOKIE_NAME = 'FP_NITRO';

export const getNitroIdFromCookies = (cookies: Record<string, string>) => {
  const value = cookies[NITRO_COOKIE_NAME];

  if (!value) return undefined;

  // nitro id cookie composition:
  // [version, id, isWT, sessionId, cookieCreationTimestamp, sessionCreationTimestamp, lastRequestTimestamp, lastSyncTimestamp, maxAttemptsToCalculateBrowserInformation]
  const [, id] = value.split('.');

  return id;
};
